import * as React from 'react';

import { useParams } from 'react-router-dom';

import { RepositoryApp } from './RepositoryApp';

export const TeamRepositoryApp: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { teamId: teamIdStr } = useParams<{ teamId: string }>();
  const parsedTeamId = teamIdStr ? parseInt(teamIdStr) : null;
  const teamId = parsedTeamId !== null && !isNaN(parsedTeamId) ? parsedTeamId : null;

  return <RepositoryApp teamId={teamId} />;
};
